// extracted by mini-css-extract-plugin
export var dataCell = "_o0-2";
export var dataRow = "_o0-0";
export var headerRow = "_o0-1";